// @flow
import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import moment from "moment";
import { ToastsStore } from "react-toasts";
import { callApi } from "../../utils/api";
import QueryAdd from "../file/QueryAdd";

interface QueryItem {
    query: string;
    location: string;
    review: string;
    other_review: string;
    created_date: string;
    is_checked: boolean;
    isValid?: boolean;
}

interface QueryNoteProps {
    fileId: string | number;
    fod_fk?: string | number;
    hideAccordion?: boolean;
}

interface QueryNoteState {
    newQueryList: QueryItem[];
    reasons: any[];
    queryLoading: boolean;
    expanded: boolean;
    isLoading: boolean;
    existing_ids: any[]
}

export default class QueryNote extends Component<QueryNoteProps, QueryNoteState> {
    static defaultProps = {
        hideAccordion: false,
        initialQueryList: [],
        readOnly: false,
        queryReason: []
    };

    constructor(props: QueryNoteProps) {
        super(props);
        this.state = {
            newQueryList: [],
            reasons: [],
            queryLoading: false,
            expanded: true,
            isLoading: false,
            existing_ids: []
        };
    }

    componentDidMount() {
        this.listreason();
        this.fetchQueryNotes();
    }

    fetchQueryNotes = () => {
        const { fileId, fod_fk } = this.props;

        const payload: any = {};
        if (fileId) payload.fileId = fileId;
        if (fod_fk) payload.fod_fk = fod_fk;

        callApi("POST", "query_validation_notes_get.php", payload)
            .then((res) => res.data)
            .then((response) => {
                if (response.success && response.data) {
                    // Get IDs from the response
                    const responseIds = response.data.existing_ids || [];

                    this.setState({
                        newQueryList: response.data.querydetail || [],
                        existing_ids: responseIds // Only store IDs that actually exist
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    listreason = () => {
        callApi("GET", "query_reason_get.php")
            .then((res) => res.data)
            .then((response) => {
                if (response.data) {
                    const files = response.data;
                    this.setState({ reasons: files });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    addQueryList = () => {
        const { newQueryList } = this.state;
        const newQuery: QueryItem = {
            query: "",
            location: "",
            review: "",
            is_checked: false,
            other_review: "",
            created_date: moment().format("DD-MM-YYYY HH:mm:ss"),
        };
        this.setState({ newQueryList: [...newQueryList, newQuery] });
    };

    handleChangequery = (e: any, index: number) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;
        const { newQueryList } = this.state;
        newQueryList[index][fieldName] = fieldValue;
        this.setState({ newQueryList });
    };

    handleDetailsChange = (value: string, key: string, index: number) => {
        const { newQueryList } = this.state;
        newQueryList[index][key] = value;
        this.setState({ newQueryList });
    };

    removeReply = (index) => {
        const { newQueryList } = this.state;
        const updatedQueryList = [
            ...newQueryList.slice(0, index),
            ...newQueryList.slice(index + 1),
        ];
        this.setState({ newQueryList: updatedQueryList });
    };

    newaddrequery = (data: any) => {
        const { newQueryList }: any = this.state;
        const newReQueryItem: any = {
            query: "",
            location: "",
            review: "",
            query_id: data.id ? data.id : data.query_id,
            other_review: "",
            created_date: moment().format("DD-MM-YYYY HH:mm:ss"),
        };
        this.setState({ newQueryList: [...newQueryList, newReQueryItem] });
    };

    validateQuery = (querydetail: QueryItem[]) => {
        let base = querydetail;
        let isValid = true;

        for (let i = 0; i < base.length; i++) {
            const document = base[i];
            if (document && document.review == "other") {
                if (!document.query || !document.review || !document.other_review) {
                    isValid = false;
                    base[i].isValid = false;
                } else {
                    base[i].isValid = true;
                }
            } else if (document && document.review != "other") {
                if (!document.query || !document.review) {
                    isValid = false;
                    base[i].isValid = false;
                } else {
                    base[i].isValid = true;
                }
            }
        }
        return isValid;
    };

    saveQuery = (): void => {
        const {
            newQueryList,
            existing_ids
        } = this.state;

        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";

        // Sort querydetail by created_date
        let querydetail: any[] = [...newQueryList];
        querydetail.sort((a, b) => {
            const dateA = moment(a.created_date, "DD-MM-YYYY HH:mm:ss").toDate();
            const dateB = moment(b.created_date, "DD-MM-YYYY HH:mm:ss").toDate();
            return dateA.getTime() - dateB.getTime();
        });

        const payload: any = {
            querydetail,
            user_idfk: userId,
            fileId: this.props.fileId,
            fod_fk: this.props.fod_fk || this.props.fileId,
            existing_ids: existing_ids  // Send existing IDs to track deletions
        };

        this.setState({ queryLoading: true });

        callApi("POST", "query_validation_notes_save.php", payload)
            .then((res) => res.data)
            .then((response) => {
                if (response.success == true) {
                    ToastsStore.success(response.message);

                    // Update existing_ids with new ones from response
                    const newExistingIds = [
                        ...(response.data?.inserted || []),
                        ...(response.data?.updated || [])
                    ];

                    this.setState({
                        queryLoading: false,
                        existing_ids: newExistingIds
                    });

                    // Refresh data to get latest
                    this.fetchQueryNotes();
                } else {
                    this.setState({ queryLoading: false });
                    ToastsStore.error(response.message);
                }
            })
            .catch((err) => {
                this.setState({ queryLoading: false });
                ToastsStore.error("Something went Wrong, Please try again!");
                console.log(err);
            });
    };

    handleRaiseQuery = async () => {
        const { newQueryList } = this.state;

        if (newQueryList && newQueryList.length > 0) {
            const isValid = this.validateQuery(newQueryList);
            if (isValid) {
                this.setState({ isLoading: true });
                await this.saveQuery();
                this.setState({ isLoading: false });
            } else {
                ToastsStore.error("Please fill all the required fields");
            }
        } else {
            await this.saveQuery();
        }
    };

    resetQueryList = () => {
        this.setState({ newQueryList: [] });
    };

    render() {
        const {
            newQueryList,
            reasons,
            queryLoading,
            isLoading,
            expanded
        } = this.state;

        const { hideAccordion } = this.props;

        if (hideAccordion) {
            return (
                <div className="query-note-container">
                    <div className="row mb-3">
                        <div className="col-md-12 text-right">
                            <button
                                type="button"
                                onClick={this.addQueryList}
                                className="btn btn-primary btn-sm"
                            >
                                <i className="feather icon-plus" /> Add Query
                            </button>
                        </div>
                    </div>

                    {newQueryList && newQueryList.length > 0 && (
                        <div className="raise-query-style" style={{ marginTop: "2%", flex: 1 }}>
                            <QueryAdd
                                addnewQueryList={newQueryList}
                                handleChange={this.handleChangequery}
                                handleDetailsChange={this.handleDetailsChange}
                                removeReply={this.removeReply}
                                newaddrequery={this.newaddrequery}
                                queryreason={reasons}
                                path={"QueryNote"}
                            />
                        </div>
                    )}

                    {newQueryList.length > 0 && (
                        <div className="row mt-3">
                            <div className="col-md-12 text-right">
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={this.handleRaiseQuery}
                                    disabled={isLoading || queryLoading}
                                >
                                    {isLoading || queryLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "Raise Query"
                                    )}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div>
                <Accordion>
                    {/* defaultActiveKey={expanded ? "1" : ""} */}
                    <Card>
                        <Accordion.Toggle
                            style={{ background: '#ffff8d', cursor: 'pointer', padding: '12px 26px' }}
                            as={Card.Header}
                            eventKey="1"
                            onClick={() => this.setState({ expanded: !expanded })}
                        >
                            <h5 className="mb-0">
                                <b>Add Query Note</b>
                            </h5>
                            <i
                                className={`icon feather ${!expanded ? 'icon-minus' : 'icon-plus'}`}
                                style={{
                                    color: "black",
                                    fontSize: "17px",
                                    fontWeight: "bold",
                                    float: "right",
                                    marginTop: "5px"
                                }}
                            />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div className="row mb-3">
                                    <div className="col-md-12 text-right">
                                        <button
                                            type="button"
                                            onClick={this.addQueryList}
                                            className="btn btn-primary btn-sm"
                                        >
                                            <i className="feather icon-plus" /> Add Query
                                        </button>
                                    </div>
                                </div>

                                {newQueryList && newQueryList.length > 0 && (
                                    <div className="raise-query-style" style={{ marginTop: "2%", flex: 1 }}>
                                        <QueryAdd
                                            addnewQueryList={newQueryList}
                                            handleChange={this.handleChangequery}
                                            handleDetailsChange={this.handleDetailsChange}
                                            removeReply={this.removeReply}
                                            newaddrequery={this.newaddrequery}
                                            queryreason={reasons}
                                            path={"QueryNote"}
                                        />
                                    </div>
                                )}

                                <div className="row mt-3">
                                    <div className="col-md-12 text-right">
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={this.handleRaiseQuery}
                                            disabled={isLoading || queryLoading}
                                        >
                                            {isLoading || queryLoading ? (
                                                <i className="fa fa-spinner fa-spin"></i>
                                            ) : (
                                                "Save Query"
                                            )}
                                        </button>
                                    </div>
                                </div>

                                {newQueryList.length === 0 && (
                                    <div className="text-center text-muted py-3">
                                        No queries added. Click "Add Query" to create a new query.
                                    </div>
                                )}
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        );
    }
}